module.exports = __webpack_public_path__ + "assets/img/LODA.71fb1194.png";